













































import { Component, Vue } from 'vue-property-decorator'
import { UserInfo } from '@/interfaces/vuexStateInterface'
import { getFigureCode, checkVerify, updateMobile } from '@/apis/myInfo/myInfo.ts'
import {getMobilexdomain} from '@/utils/utils';
import representation from '../../../router/representation'
import { Toast } from 'vant'
import i18n from '@/lang';
@Component({})
export default class MobileBindOn extends Vue {
  private isShowPopUp: boolean = false //验证码弹窗
  private checkPicCodeInputError: boolean = false
  private picCodeUrl: any = '' //图形验证码地址
  private picCodeInput: string = ''
  private sessionid: any = ''
  private codeFailMsg: string = i18n.t('ktpMy.请输入正确的验证码') as string
  private mobileText: string = ''
  private mobileDown: boolean = false
  private virtCode: string = '' //验证码
  get userInfo(): UserInfo {
    return this.$store.getters.getUserInfo
  }
  private warnInfo: boolean = false
  //验证码确定
  confirmPicCode() {
    let mobilexdomain = getMobilexdomain();
    checkVerify({ verify: this.picCodeInput, mobile: this.mobileText, sessionid: this.sessionid, type: 'saveMobile',mobilexdomain:mobilexdomain })
      .then((res: any) => {
        // 说明输入正确
        this.checkPicCodeInputError = false
        this.isShowPopUp = false
        this.mobileDown = true
      })
      .catch((e) => {
        this.checkPicCodeInputError = true
        this.codeFailMsg = e.message
        this.getPicCode()
        this.mobileDown = false
      })
  }
  keep() {
    if (this.mobileDown) {
      //进行验证手机验证码绑定操作
      updateMobile({ mobile: this.mobileText, code: this.virtCode })
        .then((res: any) => {
          Toast.success(i18n.t('ktpMy.绑定成功'))
          this.$store.dispatch('setUserInfo').then(() => {
            this.$router.go(-1)
          })
        })
        .catch((e) => {
          //该手机号已经绑定其他账号
          // this.$router.go(-1)
          // Toast.fail(e.message)
        })
    } else {
      let reg = /^1([123456789])\d{9}$/
      if (reg.test(this.mobileText)) {
        this.warnInfo = false

        // 进行请求验证码操作
        this.isShowPopUp = true
        this.getPicCode()
      } else {
        this.warnInfo = true
      }
    }
  }
  //请求验证码
  getPicCode() {
    getFigureCode()
      .then((res: any) => {
        this.sessionid = res.sessionid
        this.picCodeUrl =  res.url
      })
      .catch((e) => {
        Toast.fail(e.message)
      })
  }
  created() {
    if (this.userInfo.mobile != '') {
      this.$setNavInfo({
        type: 'normal',
        title: i18n.t('ktpMy.更换手机号') as string,
        showTitle: true,
      })
    } else {
      this.$setNavInfo({
        type: 'normal',
        title: i18n.t('ktpMy.绑定手机号') as string,
        showTitle: true,
      })
    }
  }
}
